import { InjectionKey, Ref } from 'vue'

export const showMenuSymbol: InjectionKey<Ref<boolean>> = Symbol('showMenu')
